<template>
  <div>
    <SimpleNav />
    <h3>More Info</h3>
    <div class="">
      <div class="row flow-text">
        <div class="col s4"><h5>Phone:</h5> (562)-316-7743</div>
        <div class="col s4"><h5>Email:</h5> hmsanchez98@gmail.com</div>
        <div class="col s4">
          <h5>Resume:</h5>
          <a
            href="https://drive.google.com/open?id=1GOADqfCuoX2rgT0aqU1gNNjbtm6k6i5S"
            target="_blank"
          >View</a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import SimpleNav from "@/components/SimpleNav.vue";

export default {
  name: "ExtraPage",
  components: {
    SimpleNav
  }
};
</script>

<style>

</style>